import {
  Collapse,
  InteractiveContainer,
} from "@jugl-web/ui-components/cross-platform";
import { cx } from "@jugl-web/utils";
import React from "react";
import { ReactComponent as ChevronIcon } from "./assets/chevron.svg";

export const FaqEntry: React.FC<{
  question: string;
  answer: string;
  isOpen: boolean;
  onOpenSwitch: () => void;
}> = ({ answer, question, isOpen, onOpenSwitch }) => (
  <div
    className={cx(
      "hover:bg-grey-100 overflow-hidden rounded-2xl px-8 transition-all duration-300",
      isOpen ? "bg-grey-100 py-6" : "bg-transparent py-4"
    )}
  >
    <InteractiveContainer
      className="flex cursor-pointer select-none items-center justify-between"
      onClick={onOpenSwitch}
    >
      <div className="text-dark flex items-center gap-3 text-lg font-medium">
        <span className="text-xl leading-none">•</span>
        <span>{question}</span>
      </div>
      <ChevronIcon
        className={cx(
          "text-[#1B1C1F] transition-transform duration-300",
          isOpen && "rotate-180"
        )}
      />
    </InteractiveContainer>
    <Collapse isOpen={isOpen}>
      <div className="text-dark-700 pt-4 pl-6 leading-relaxed">{answer}</div>
    </Collapse>
  </div>
);
